// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__2q2dW","title":"Intro_title__nQkmC","left":"Intro_left__LNnxB","logo-list":"Intro_logo-list__2bK_-","right":"Intro_right__1PyCC"};